import { functions } from "../firebase";

export type ExperimentEvidenceSide = {
  value: number | null;
  sampleSize: number | null;
};

export type ExperimentEvidence = {
  metric: string | null;
  control: ExperimentEvidenceSide;
  candidate: ExperimentEvidenceSide;
  ageDays: number | null;
};

export type ExperimentTask = {
  id: string;
  agentId:
    | "milo"
    | "mara"
    | "nudge"
    | "oasis"
    | "solo"
    | "lens"
    | "funnel";
  sourceAgentId?: "mara" | "oasis";
  agentName: string;
  agentRole: string;
  status: string;
  cycle: string | null;
  category: string | null;
  cohortKey: string | null;
  platform: string | null;
  experimentId: string | null;
  hypothesis: string | null;
  primaryMetric: string | null;
  mutation: string | null;
  measurementWindowDays: number | null;
  startedAt: string | null;
  updatedAt: string | null;
  completedAt: string | null;
  verdict: string | null;
  reason: string | null;
  claimedBy: string | null;
  claimExpiresAt: string | null;
  blockedReasons: string[];
  evidence: ExperimentEvidence;
};

export type ExperimentAgent = {
  id: ExperimentTask["agentId"];
  name: string;
  role: string;
  configured: boolean;
  enabled: boolean;
  autoStart: boolean;
  lastRunAt: string | null;
  lastQueueSyncAt: string | null;
  attention: {
    pendingCount: number;
    blockedCount: number;
    attentionRequired: boolean;
  } | null;
  tasks: ExperimentTask[];
};

export type ExperimentDashboard = {
  communityId: string;
  generatedAt: string;
  agents: ExperimentAgent[];
};

export const getExperimentDashboard = async (
  communityId: string
): Promise<ExperimentDashboard> => {
  const callable = functions.httpsCallable("getExperimentDashboard");
  const result = await callable({ communityId });
  return result.data as ExperimentDashboard;
};

export type NotificationExperimentCommandAction =
  | "start"
  | "evaluate"
  | "rollback";

export const controlNotificationExperiment = async (input: {
  communityId: string;
  taskId: string;
  action: NotificationExperimentCommandAction;
  reason?: string;
}): Promise<{
  commandId: string;
  status: "queued";
  action: NotificationExperimentCommandAction;
  taskId: string;
  productionExperimentStarted: false;
}> => {
  const callable = functions.httpsCallable(
    "controlNotificationExperiment"
  );
  const result = await callable(input);
  return result.data as any;
};
